import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AdminService } from 'src/app/core/services/admin.service';
import { DeliveryMethodDto } from 'src/app/shared/interfaces';
import { AddDeliveryMethodComponent } from './add-delivery-method/add-delivery-method.component';
import { DeleteMethodConfirmComponent } from './delete-method-confirm/delete-method-confirm.component';
import { IsLoadingService } from '@service-work/is-loading';

@Component({
  selector: 'app-delivery-methods',
  templateUrl: './delivery-methods.component.html',
  styleUrls: ['./delivery-methods.component.scss'],
})
export class DeliveryMethodsComponent {
  deliveryMethods: DeliveryMethodDto[];
    constructor(private adminService: AdminService, private dialog: MatDialog, private isLoadingService: IsLoadingService,) {}

  public dialogConfig: MatDialogConfig = {
    width: '60%',
    height: '100%',
    maxWidth: 600,
    minWidth: 400,
    maxHeight: 400,
  };

  getDeliveryMethods() {
    this.isLoadingService.add();
    this.adminService.getDeliveryMethods().subscribe((res: any) => {
      this.deliveryMethods = res?.data;
    }).add(() => {
      this.isLoadingService.remove();
    });;
  }

  ngOnInit() {
    this.getDeliveryMethods();
  }
  addNewDeliveryMethod() {
    this.dialog
      .open(AddDeliveryMethodComponent, {
        ...this.dialogConfig,
        data: {
          editMode: false,
        },
      })
      .afterClosed()
      .subscribe((res: any) => {
        this.getDeliveryMethods();
      });
  }

  editDeliveryMethod(method: DeliveryMethodDto) {
    this.dialog
      .open(AddDeliveryMethodComponent, {
        ...this.dialogConfig,
        data: {
          deliveryMethod: method,
          editMode: true,
        },
      })
      .afterClosed()
      .subscribe((res: any) => {
        this.getDeliveryMethods();
      });
  }

  deleteDeliveryMethod(method: DeliveryMethodDto) {
    this.dialog.open(DeleteMethodConfirmComponent).afterClosed().subscribe((res: string | null) => {
      if (res === 'delete') {
        this.adminService.deleteDeliveryMethod(method.id.toString()).subscribe((res: any) => {
          this.getDeliveryMethods();
        })
      }
    })
  }
}
